import React, { Component } from 'react';
import '../../../App.css';

class row extends Component {
    constructor(props){
        super(props);
    }

    static defaultProps = {
      label:'',
      description:'',
      author:'',
      charge:'',
      description2:'',
      author2:'',
      charge2:''
    }

  render() {
    return (
      <div className="row">
        <div className="title">
          <h3>{this.props.label}</h3>
        </div>
        <div className="row-box-container">
          <div className="row-box">
            <p>{this.props.description}</p><br/>
            <label>{this.props.author}</label><br/>
            <label>{this.props.charge}</label>
          </div>
          <div className="row-box">
            <p>{this.props.description2}</p><br/>
            <label>{this.props.author2}</label><br/>
            <label>{this.props.charge2}</label>
          </div>
        </div>
      </div>
    );
  }
}

export default row;


// WEBPACK FOOTER //
// ./src/components/reusables/row/index.js